import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'workflowStepText'
})
export class WorkflowStepTextPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    var ret = "";
    switch(value) {
        case null:
            ret = "created" //created
            break;
        case "assignment":
            ret = "Assigné" //started
            break;
        case "acceptance":
            ret = "Déplacement" //assigned, waiting for answer
            break;
        case "move":
            ret = "Déplacement" //in transit
            break;
        case "clean":
            ret = "Nettoyage" //doing the job
            break;
        case "standby":
          ret = "En Attente" //on standby
              break;
        case "end":
          ret = "" //completed
              break;
        default:
            break;
    }
    return ret;
  }

}